import React, 
       { useState, 
         useEffect, 
         useRef                      }     from "react";
import { useLoader                   }     from "components/Covers/loadingCover";
import { useInfoMsgModal}                  from "components/Covers/infoMessageModal";
import { useToastMessage             }     from "components/Covers/toastMessage";
import { BtnCloseAction}                   from "components/Buttons/Close/BtnClose";
import   MainStyle                         from "components/UI/main.module.scss";
import { useNavigate                 }     from "react-router-dom";
import { DefaultLoadingLogo,
         Heimdall,
         GetLabel,
         SetLastFeature,
         GetAppLang,
         DavidCopperfield             }     from "Utilities/utils";
import { getData                      }     from "./Report_4_Service";
import { InputGeneral                 }     from "components/Field/field";         
// BEGIN AG AGRID
import { AgGridReact                  }     from "ag-grid-react";
import { AllCommunityModule,
         ModuleRegistry               }     from 'ag-grid-community';
import { AG_GRID_LOCALE_BR            }     from '@ag-grid-community/locale';
import { useFilter                    }     from "components/Menu/menu";
import   * as DateUtils                     from "components/Date/date";
import   dayjs                              from "dayjs";

// #region Object Template
let appLang = null;
let blank_search_param_obj = {
    DT_INIT           : DateUtils.DateToIsoString(DateUtils.setDefaultInitDate()),
    DT_FN             : DateUtils.DateToIsoString(DateUtils.setDefaultFinalDate()),
};
// #endregion

// #region Layout Helppers
const DefaultPadding = () =>{
    return(<div className={MainStyle.py_3}/>);
};
//#endregion

// #region Filter Data
const FilterOptions = React.memo(({...props}) => {
    const { setRowData,
            searchParam,
            setSearchParam  }      = props;
    const { showInfoMessage }      = useInfoMsgModal();
    const { showLoader, 
            hideLoader      }      = useLoader();

    async function startSearch() {
        let dtobj0 = dayjs(searchParam.DT_INIT);
        let dtobj1 = dayjs(searchParam.DT_FN);
        let dtDiff = dtobj1.diff(dtobj0, "day");
        
        if (dtobj0 > dtobj1) {
            showInfoMessage({header: GetLabel(appLang, 54), message: GetLabel(appLang, 230)});
            return;
        }
        if (dtDiff < 180) {
            showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
            let data = await getData(searchParam);
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    let arr = [];
                    for(var j = 0; j < data.length; j++) {
                        arr.push(data[j]);
                    }
                    setRowData(arr);
                    hideLoader();
                }
                else {
                    hideLoader();
                    showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                }
            }
        }
        else {
            showInfoMessage({header: GetLabel(appLang, 54), message: GetLabel(appLang, 580)});
            return;
        }
    }

    useEffect(() => {
    },[searchParam]);

    
    return(
        <>
            <div className={[MainStyle.overflow_y_scroll].join(" ")}>                             
                {/*         DT Init       */}         
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={[MainStyle.m_3].join(" ")}>
                                <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                    {GetLabel(appLang, 523)}
                                </span>                      
                                <DateUtils.DatePicker
                                    value={DateUtils.InitDateFromIsoString(searchParam.DT_INIT)}
                                    placeholder={GetLabel(appLang, 487)}
                                    style={{ width: "100%" }}
                                    className={[MainStyle.mt_2].join(" ")}
                                    onChange={(date) => {
                                        setSearchParam(prev => {
                                            return({
                                                ...prev,
                                                DT_INIT: DateUtils.DateToIsoString(date),
                                            });
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/*         DT Fin        */}
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.border_bottom}>
                            <div className={[MainStyle.m_3].join(" ")}>
                                <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_6, MainStyle.fw_semibold].join(" ")}>
                                    {GetLabel(appLang, 524)}
                                </span>
                                <DateUtils.DatePicker
                                    value={DateUtils.FinDateFromIsoString(searchParam.DT_FN)}
                                    placeholder={GetLabel(appLang, 488)}
                                    style={{ width: "100%" }}
                                    className={[MainStyle.mt_2].join(" ")}
                                    onChange={(date) => {
                                        setSearchParam(prev => {
                                            return({
                                                ...prev,
                                                DT_FN: DateUtils.DateToIsoString(date),
                                            });
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg}>
                    <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                        <button
                            style={{width: '100%'}}
                            className={[MainStyle.btn_green, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.text_white,
                                        MainStyle.py_3,
                                        MainStyle.px_3].join(" ")}
                            onClick={async () => {startSearch();}}
                        >
                            {GetLabel(appLang, 238)}
                        </button>
                    </div>
                </div>                            
            </div>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg}>
                    <div className={[MainStyle.my_2, MainStyle.mx_3].join(" ")}>
                        <button
                            style={{width: '100%'}}
                            className={[MainStyle.btn_vanilla, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_6,
                                        MainStyle.text_body,
                                        MainStyle.py_3,
                                        MainStyle.px_3].join(" ")}
                            onClick={async () => {
                                setSearchParam(blank_search_param_obj);
                            }}
                        >
                            {GetLabel(appLang, 239)}
                        </button>
                    </div>
                </div>                            
            </div>
        </>
    );

});
// #endregion


const CloseObj  = ({handleExit}) => {
    return (
        <>
            <div className={MainStyle.mt_3}/>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_1}>                            
                </div>
                <div className={MainStyle.col_11}>
                    <div className={[MainStyle.text_end, MainStyle.mx_3].join(" ")}>
                        {<BtnCloseAction click_action={handleExit}/>}
                    </div>
                </div>
            </div>
            <div className={MainStyle.mt_3}/>
        </>
    );

};


const TableGrid = React.memo(({...other}) => {
    const { setData,
            setScreenType,
            searchParam,
            setSearchParam,
            rowData,
            setRowData,
            firstLoad,    
            setFirstLoad                } = other;
    const [ searchText,  setSearchText  ] = useState('');
    const [ columnDefs,  setcolumnDefs  ] = useState([]);
    const { showFilter, hideFilter      } = useFilter(); 
    const gridRef                         = useRef();
    const { showLoader,  hideLoader     } = useLoader();

    ModuleRegistry.registerModules([AllCommunityModule]);

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true,
    };
    
    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    const ViewItem = (props) => {        
        return(
            <>
                <div onClick={() => {setData(parseInt(props.data.ID)); setScreenType(3);}} className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 576 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"/>
                    </svg>
                </div>
            </>
        );
    };

    const defaultCol = [
        {
            headerName: GetLabel(appLang, 571),
            marryChildren: true,
            children: [
                DavidCopperfield(12,89,2) && {
                    columnGroupShow: 'open', 
                    headerName: GetLabel(appLang, 489),
                    field: 'ID',
                    cellRenderer: ViewItem,
                    cellClass: [MainStyle.table_text_center].join(" "), 
                    headerClass: MainStyle.table_header_center,
                    flex: 0,
                },
            ]
        },
        {
            headerName: GetLabel(appLang, 572),
            marryChildren: true,
            children: [
                { headerName: GetLabel(appLang, 34),   field: "ID"     ,filter: true , flex: 0, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" ")}    ,
                { headerName: GetLabel(appLang, 36),   field: "post_title"   ,filter: true , flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
            ]
        },
        {
            headerName: GetLabel(appLang, 573),
            marryChildren: true,
            children: [
                { headerName: GetLabel(appLang, 318),       field: "Escola",    filter: true, flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                
                { headerName: GetLabel(appLang, 319),       field: "Área",      filter: true, flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                
                { headerName: GetLabel(appLang, 321),       field: "Programa",  filter: true, flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,            
                { headerName: GetLabel(appLang, 322),       field: "Empresa",   filter: true, flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                    
                { headerName: GetLabel(appLang, 564),       field: "Turma",     filter: true, flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                                
                { headerName: "Data",                       field: "Data",      filter: true, flex: 0, cellRenderer: DateUtils.DisplayGridDatetime, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" ")}    ,
            ]
        },  
        {
            headerName: GetLabel(appLang, 497),
            marryChildren: true,
            children: [
                { headerName: "1",                     field: "Linha1",    filter: true, flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                
                { headerName: "2",                     field: "Linha2",    filter: true, flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                
                { headerName: "3",                     field: "Linha3",    filter: true, flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,                
                { headerName: "4",                     field: "Linha4",    filter: true, flex: 0, cellStyle: {}, cellClass: [MainStyle.table_text_left].join(" ")}    ,
            ]
        },                
    ].filter(Boolean);

    useEffect(() => {
        const fetchData = async () => {
            showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
            let data = await getData(searchParam);
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    setRowData(data);
                    hideLoader();
                }
                else {
                    hideLoader();
                }
            }
            else {
                hideLoader();
            }
        };
        if (searchParam) {
            setcolumnDefs(defaultCol);
            showFilter({jsx: 
                            <FilterOptions 
                                setRowData={setRowData} 
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                            />
            });
        }
        if (!firstLoad) {
            fetchData(); 
            setFirstLoad(true); 
        }
    },[firstLoad, rowData, setRowData , searchParam]);

    return (
        <React.Fragment>
            <DefaultPadding/>
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_9}></div>
                        <div className={MainStyle.col_lg_3}>
                            <div className={[MainStyle.d_flex].join(" ")}>
                                <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                    <svg 
                                        xmlns="http://www.w3.org/2000/svg" 
                                        viewBox="0 0 512 512"
                                        className={MainStyle.small_ico_search_bar}
                                    >
                                        <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                    </svg>
                                </div>
                                <InputGeneral 
                                    value={searchText}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                                    onChange={onQuickFilterChanged}
                                    placeholder={GetLabel(appLang, 33)}
                                />
                                <CloseObj handleExit={() => {setScreenType(1);}}/>  
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ height: '40rem'}}>
                    <AgGridReact 
                        ref={gridRef}
                        rowData={rowData}
                        columnDefs={columnDefs}
                        gridOptions={gridOptions}
                        quickFilterText={searchText}
                    />
                </div>
            </div>
        </React.Fragment>
    );
});

const OldReport = React.memo(({...other}) => {
    const { setScreenType, data } = other;

    useEffect(() => {
    }, [setScreenType, data]);
    return (
        <React.Fragment>
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <CloseObj handleExit={() => {setScreenType(2)}}/>                  
                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col}>
                            <div style={{ width: '100%', height: '50vh' }}>
                                <iframe
                                    src={`https://survey.ise.org.br/wp-admin/admin.php?page=single_report&export_report=true&order_id=${data}`}
                                    width="100%"
                                    height="100%"
                                    style={{ border: 'none' }}
                                    title="Old Report"
                                />
                            </div>
                        </div>
                    </div>                    
                </div>
            </div>
        </React.Fragment>
    );
});

const OldLogin = React.memo(({...other}) => {
    const { setScreenType, data } = other;

    useEffect(() => {
    }, [setScreenType, data]);
    return (
        <React.Fragment>
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <CloseObj handleExit={() => {setScreenType(2)}}/>                  
                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col}>
                            <div style={{ width: '100%', height: '50vh' }}>
                                <iframe
                                    src={`https://survey.ise.org.br/wp-admin`}
                                    width="100%"
                                    height="100%"
                                    style={{ border: 'none' }}
                                    title="Old Report"
                                />
                            </div>
                        </div>
                    </div>                    
                </div>
            </div>
        </React.Fragment>
    );
});

export const Report_4_Page = () => {
    const [ screenType,  setScreenType          ]   = useState(1);
    const [ searchParam, setSearchParam         ]   = useState(blank_search_param_obj);
    const [ rowData,     setRowData             ]   = useState([]);
    const [ data,        setData                ]   = useState([]);
    const navigate                                  = useNavigate();
    const [firstLoad,    setFirstLoad           ]   = useState(false);

    
    useEffect(() => {
        if (!Heimdall([12])) {
            navigate('/home');
        }
        else {
            SetLastFeature(9999);
        }
    }, []);
    
    return (
        <React.Fragment>
            {
                screenType === 1 ?
                    <React.Fragment>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_12}>
                                <div className={[MainStyle.mx_3].join(" ")}>
                                    <DefaultPadding/>
                                    <div className={[MainStyle.mx_3, MainStyle.bg_warning, MainStyle.text_dark, MainStyle.text_wrap, MainStyle.rounded_3, MainStyle.border, MainStyle.shadow].join(" ")}>
                                        <div className={MainStyle.m_3}>
                                            <span className={[MainStyle.fs_6].join(" ")}>
                                                {GetLabel(appLang, 587)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <DefaultPadding/>                                              
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_12}>
                                <div className={[MainStyle.mx_3].join(" ")}>                                    
                                    <OldLogin setScreenType={setScreenType} data={data}/>
                                </div>
                            </div>
                        </div>                            
                        <DefaultPadding/>
                    </React.Fragment>
                :                              
                screenType === 2 ? 
                    <React.Fragment>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_12}>
                                <div className={[MainStyle.mx_3].join(" ")}>
                                    <DefaultPadding/>
                                    <div className={[MainStyle.mx_3, MainStyle.bg_warning, MainStyle.text_dark, MainStyle.text_wrap, MainStyle.rounded_3, MainStyle.border, MainStyle.shadow].join(" ")}>
                                        <div className={MainStyle.m_3}>
                                            <span className={[MainStyle.fs_6].join(" ")}>
                                                {GetLabel(appLang, 582)}
                                            </span>
                                        </div>
                                    </div>                                    
                                    <TableGrid
                                        firstLoad={firstLoad}
                                        setFirstLoad={setFirstLoad}
                                        setData={setData}
                                        setScreenType={setScreenType}
                                        rowData={rowData}
                                        setRowData={setRowData}
                                        searchParam={searchParam}
                                        setSearchParam={setSearchParam}
                                    />
                                </div>
                            </div>
                        </div>
                        <DefaultPadding/>
                    </React.Fragment>
                :
                screenType === 3 ?
                    <React.Fragment>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_12}>
                                <div className={[MainStyle.mx_3].join(" ")}>
                                    <DefaultPadding/>
                                    <div className={[MainStyle.mx_3, MainStyle.bg_warning, MainStyle.text_dark, MainStyle.text_wrap, MainStyle.rounded_3, MainStyle.border, MainStyle.shadow].join(" ")}>
                                        <div className={MainStyle.m_3}>
                                            <span className={[MainStyle.fs_6].join(" ")}>
                                                {GetLabel(appLang, 583)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <DefaultPadding/>                                              
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_12}>
                                <div className={[MainStyle.mx_3].join(" ")}>                                    
                                    <OldReport setScreenType={setScreenType} data={data}/>
                                </div>
                            </div>
                        </div>                            
                        <DefaultPadding/>
                    </React.Fragment>
                :
                    null
            }        
        </React.Fragment>            
    );
};